<template>
    <div>
        <slot :activate="activateIndex" :activeIndex="activeIndex" />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';
import SimpleTab from './SimpleTab.vue';

@Component
export default class SimpleTabs extends Vue {
    @Prop({ default: true, type: Boolean }) activateFirst: boolean;

    tabs: SimpleTab[] = [];

    get activeIndex() {
        return this.tabs.findIndex(tab => tab.active);
    }

    @Provide()
    register(tab: SimpleTab): void {
        this.tabs.push(tab);
        // activate first item by default
        if (this.activateFirst) {
            if (this.tabs.length === 1) {
                this.activate(tab);
            }
        }
    }

    @Provide()
    activate(tab: SimpleTab): void {
        if (tab.active) {
            return;
        }
        this.tabs.forEach(t => {
            t.active = false;
        });
        tab.active = true;
    }

    activateIndex(index: number): void {
        if (index >= this.tabs.length) return;
        if (index < 0) {
            this.tabs.forEach(t => {
                t.active = false;
            });
        } else {
            this.activate(this.tabs[index]);
        }
    }
}
</script>
